import { useTheme } from '@nexelem/deprecated-theme';
import { ContextedTableProps } from '@nexelem/table';
import { useMemo } from 'react';

export const useTableProps = (defaultSortColumn?: string, tableProps: Partial<ContextedTableProps> = {}) => {
  const {
    palette: { getColor },
    client: { table },
  } = useTheme();

  return useMemo((): Partial<ContextedTableProps> => {
    return {
      initialState: defaultSortColumn
        ? { sorting: { sortModel: [{ field: defaultSortColumn, sort: 'asc' }] } }
        : undefined,
      disableMultipleColumnsSorting: true,
      sortingOrder: ['desc', 'asc'],
      sortingMode: 'server',
      filterMode: 'server',
      rowsLoadingMode: 'client',
      paginationMode: 'server',
      pagination: false,
      sx: {
        //TODO: remove getColor
        '--DataGrid-containerBackground': getColor(table.common.backgroundColor),
        '--DataGrid-pinnedBackground': getColor(table.common.backgroundColor),
        '--DataGrid-rowBorderColor': getColor(table.common.rowBorder),
        '--unstable_DataGrid-overlayBackground': getColor(table.common.rowBorder),
      },
      ...tableProps,
    };
  }, [defaultSortColumn, getColor, table.common.backgroundColor, table.common.rowBorder, tableProps]);
};
